/* eslint-disable no-console */
class Logger {
  private logLevels = ['log', 'info', 'debug', 'warn', 'error'];
  private isErrorEnabled: boolean | undefined;
  private isWarnEnabled: boolean | undefined;
  private isDebugEnabled: boolean | undefined;
  private isInfoEnabled: boolean | undefined;
  private isLogEnabled: boolean | undefined;

  private _logLevel: string | undefined = process.env.VUE_APP_LOG_LEVEL;

  constructor() {
    this.setLogLevels();
  }

  private setLogLevels(): void {
    this.isErrorEnabled = this.isLogLevelActive('error');
    this.isWarnEnabled = this.isLogLevelActive('warn');
    this.isDebugEnabled = this.isLogLevelActive('debug');
    this.isInfoEnabled = this.isLogLevelActive('info');
    this.isLogEnabled = this.isLogLevelActive('log');
  }

  get logLevel(): string | undefined {
    return this._logLevel;
  }

  set logLevel(level: string | undefined) {
    this._logLevel = level;
    this.setLogLevels();
  }

  private isLogLevelActive(inputLevel: string): boolean {
    if (this.logLevel) {
      return this.logLevels.indexOf(inputLevel) <= this.logLevels.indexOf(this.logLevel);
    }
    return false;
  }

  public error(...args: unknown[]) {
    if (!this.isErrorEnabled) {
      return;
    }

    console.error(...args);
  }

  public warn(...args: unknown[]) {
    if (!this.isWarnEnabled) {
      return;
    }

    console.warn(...args);
  }

  public debug(...args: unknown[]) {
    if (!this.isDebugEnabled) {
      return;
    }

    console.debug(...args);
  }

  public info(...args: unknown[]) {
    if (!this.isInfoEnabled) {
      return;
    }

    console.info(...args);
  }

  public log(...args: unknown[]) {
    if (!this.isLogEnabled) {
      return;
    }

    console.log(...args);
  }
}

export default new Logger();
